<template>
  <div
    id="setting-receiver"
    :class="isDisabledClass"
    class="col-12 mb-4 overflow-auto pb-4"
    @click.self="isShow(false)"
  >
    <div class="user-selector">
      <div v-if="selectUserRoles" class="setting-owner">
        <p class="my-2">
          <strong>ต้องการส่งข่าวนี้ถึง</strong>
        </p>
        <label class="select-input">
          เจ้าของ
          <input
            v-model="selectUserRoles"
            v-validate="'required'"
            :disabled="!canUpdateContent"
            type="checkbox"
            value="owner"
            name="userRole"
            @change="setUserRoles"
          />
          <span
            :class="{ error: errors.has('userRole') }"
            class="checkmark checkbox"
          ></span>
        </label>
        <label class="select-input">
          ผู้อยู่อาศัย
          <input
            v-model="selectUserRoles"
            v-validate="'required'"
            :disabled="!canUpdateContent"
            type="checkbox"
            value="resident"
            name="userRole"
            @change="setUserRoles"
          />
          <span
            :class="{ error: errors.has('userRole') }"
            class="checkmark checkbox"
          ></span>
        </label>
        <label class="select-input">
          ผู้เช่า
          <input
            v-model="selectUserRoles"
            v-validate="'required'"
            :disabled="!canUpdateContent"
            type="checkbox"
            value="renter"
            name="userRole"
            @change="setUserRoles"
          />
          <span
            :class="{ error: errors.has('userRole') }"
            class="checkmark checkbox"
          ></span>
        </label>
        <label class="select-input">
          ผู้ทำสัญญา
          <input
            v-model="selectUserRoles"
            v-validate="'required'"
            :disabled="!canUpdateContent"
            type="checkbox"
            value="contract"
            name="userRole"
            @change="setUserRoles"
          />
          <span
            :class="{ error: errors.has('userRole') }"
            class="checkmark checkbox"
          ></span>
        </label>
        <label class="select-input">
          ผู้จอง
          <input
            v-model="selectUserRoles"
            v-validate="'required'"
            :disabled="!canUpdateContent"
            type="checkbox"
            value="booking"
            name="userRole"
            @change="setUserRoles"
          />
          <span
            :class="{ error: errors.has('userRole') }"
            class="checkmark checkbox"
          ></span>
        </label>
        <label class="select-input">
          คนทั่วไป
          <input
            v-model="selectUserRoles"
            v-validate="'required'"
            :disabled="!canUpdateContent"
            type="checkbox"
            value="visitor"
            name="userRole"
            @change="setUserRoles"
          />
          <span
            :class="{ error: errors.has('userRole') }"
            class="checkmark checkbox"
          ></span>
        </label>
        <!-- Rent to owned -->
        <label class="select-input">
          ผู้เช่าเป็นเจ้าของ
          <input
            v-model="selectUserRoles"
            v-validate="'required'"
            :disabled="!canUpdateContent"
            type="checkbox"
            value="rentToOwn"
            name="userRole"
            @change="setUserRoles"
          />
          <span
            :class="{ error: errors.has('userRole') }"
            class="checkmark checkbox"
          ></span>
        </label>
      </div>
    </div>
    <div>
      <label class="select-input">
        เฉพาะพนักงาน SC
        <input
          v-model="selectSCOnly"
          :disabled="!canUpdateContent"
          type="checkbox"
          value="35854"
          name="checkSCOnly"
          @change="setSCHomeOnly"
        />
        <span
          :class="{ error: errors.has('userRole') }"
          class="checkmark checkbox"
        ></span>
      </label>
    </div>
    <div v-if="projectSelectRules && canUpdateContent">
      <input
        v-model="selectProjects.length"
        v-validate="'required|min_value:1'"
        type="hidden"
        name="projects"
      />
      <p class="my-2">
        <strong>เลือกโครงการที่จะประกาศ</strong>
      </p>
      <project-province-selector
        :disabled="!canUpdateContent"
        :value="selectProjects"
        @allProject="selectProjectAll"
        @input="handleChangeInput"
      ></project-province-selector>
    </div>
  </div>
</template>
<script>
import axios from "axios"
import "bootstrap"
import { getCookie, Auth } from "@/lib/cookie"
import ProjectProvinceSelector from "@/lib/components/ProjectProvinceSelector"

export default {
  components: { ProjectProvinceSelector },
  props: {
    dataSettings: {
      type: null,
      default: undefined,
    },
    approvedAt: {
      type: null,
      default: undefined,
    },
    canUpdateContent: {
      type: null,
      default: undefined,
    },
    isThaiLanguage: {
      type: null,
      default: undefined,
    },
  },
  data() {
    return {
      tabActive: "projects",
      filterBrand: "",
      filterProjectType: "",
      projects: [],
      projectGroups: {},
      projectTypes: [
        { key: "", name: "ทุกประเภท" },
        { key: "H", name: "แนวสูง" },
        { key: "L", name: "แนวราบ" },
      ],
      searchProject: "",
      selectUserRoles: [],
      selectProjects: [],
      selectHomes: "",
      homeType: 1,
      projectType: 1,
      selectSCOnly: false,
    }
  },
  computed: {
    projectSelectRules() {
      return (
        this.selectUserRoles.includes("owner") ||
        this.selectUserRoles.includes("resident") ||
        this.selectUserRoles.includes("renter") ||
        this.selectUserRoles.includes("contract") ||
        this.selectUserRoles.includes("booking") ||
        this.selectUserRoles.includes("rentToOwn")
      )
    },
    isDisabledClass() {
      return {
        "disable-content": !this.isThaiLanguage,
      }
    },
  },
  watch: {
    "dataSettings.selectProjects": function mapSelectProjects() {
      this.selectProjects = this.dataSettings.selectProjects
    },
    "dataSettings.owner": function mapUserRoles() {
      this.selectUserRoles = this.dataSettings.owner
    },
    "dataSettings.selectHomes": function mapSelectHomes() {
      let selectHomes = null
      if (this.dataSettings.selectHomes !== null) {
        selectHomes = this.dataSettings.selectHomes.split(",")
        if (selectHomes.indexOf("35854") > -1) {
          this.selectSCOnly = true
        }
      }
    },
  },
  beforeMount() {
    this.getProjects()
  },
  methods: {
    isShow() {
      this.$emit("isshow", false)
    },
    setTab(tab) {
      this.tabActive = tab
    },
    getProjects() {
      const vm = this
      const data = { searchText: vm.searchProject }

      if (vm.filterProjectType && vm.filterProjectType.key) {
        data.type = vm.filterProjectType.key
      }

      axios
        .get(`${process.env.HOST}/api/admin/projects`, {
          params: data,
          headers: {
            Authorization: `Bearer ${getCookie(Auth.AccessToken)}`,
          },
        })
        .then((res) => {
          vm.projects = res.data
          vm.projectGroups = {}
          vm.projects.forEach((project) => {
            if (!vm.projectGroups[project.projectGroup]) {
              vm.projectGroups[project.projectGroup] = [project]
            } else {
              vm.projectGroups[project.projectGroup].push(project)
            }
          })
        })
    },
    selectProjectAll() {
      this.selectProjects = this.projects
      this.$emit("setProjects", this.projects)
    },
    handleChangeInput(value) {
      this.selectProjects = value || []
      this.$emit("setProjects", this.selectProjects)
    },
    selectProjectGroup(name) {
      this.projectGroups[name].forEach((project) => {
        if (!this.checkProjectDupicate(project)) {
          this.selectProjects = this.selectProjects.concat(project)
        }
      })
      this.$emit("setProjects", this.selectProjects)
    },
    removeProjectAll() {
      this.selectProjects = []
      this.$emit("setProjects", this.selectProjects)
    },
    selectProject(project) {
      if (!this.checkProjectDupicate(project)) {
        this.selectProjects = this.selectProjects.concat(project)
        this.$emit("setProjects", this.selectProjects)
      }
    },
    removeProject(index) {
      this.selectProjects.splice(index, 1)
      this.$emit("setProjects", this.selectProjects)
    },
    checkProjectDupicate(project) {
      return this.selectProjects.some((pro) => {
        if (pro.projectId === project.projectId) {
          return true
        }
        return false
      })
    },
    filterProjectByProjectType(type) {
      this.filterProjectType = type
      this.getProjects()
    },
    setUserRoles() {
      if (this.canUpdateContent) {
        this.$emit("setUserRoles", this.selectUserRoles)
      }
    },
    setSCHomeOnly() {
      if (this.canUpdateContent) {
        if (this.selectSCOnly) {
          this.selectHomes = "35854"
        } else {
          this.selectHomes = null
        }
        this.$emit("setHomes", this.selectHomes)
      }
    },
    async validate() {
      const result = await this.$validator.validate()
      this.$emit("validate", result)
      return result
    },
  },
}
</script>
<style lang="scss" scoped>
.project-box {
  border-radius: 15px;
  border: 1px solid #e0e0e0;
  overflow: scroll;
  max-height: calc(100vh - 455px);

  &.error {
    border-color: $red;
  }
  .head {
    border-bottom: 1px solid #e0e0e0;
    max-height: 49px;
  }
  .results-panel {
    border-left: 1px solid #e0e0e0;

    &.no-left-border {
      border-left: none;
    }
  }
  .filter {
    padding: 6px 10px 0 0;
    text-align: right;
  }
}

.input-group-addon {
  border-top-left-radius: 50%;
  border-bottom-left-radius: 50%;
  background-color: #ffffff;
  border: none;
}
.form-control {
  height: 32px;
  background-color: #ffffff;
  border: none;
}
.dropdown {
  margin-left: 5px;
  .sc-btn {
    font-weight: 500;
    border-radius: 8px !important;
    padding: 3px 10px;
    width: auto;
  }
}
.list-height {
  max-height: calc(100vh - 400px);
}
.projects {
  background-color: #ffffff;
  height: calc(100% - 110px);
  padding: 10px;
  overflow-y: auto;

  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.31;
  letter-spacing: -0.1px;
  text-align: left;
  color: #4a4a4a;

  &-counter {
    font-weight: bold;
    color: $orange;
  }
  &-head {
    padding: 10px;
    line-height: 1.7;
    border-bottom: 1px solid #e0e0e0;
  }
  &-remove {
    font-size: 12px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.64;
    letter-spacing: -0.1px;
    text-align: right;
    color: #8c8786;
  }
  .all {
    font-weight: bold;
    color: $black;
    margin-bottom: 6px;
  }
}
.project {
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: -0.1px;
  text-align: left;
  color: #4a4a4a;
  padding-left: 16px;
  border-left: 1px solid #979797;

  &-group {
    cursor: pointer;
    font-size: 16px;
    font-weight: bold;
    line-height: 1.38;
    letter-spacing: -0.1px;
    color: $black;
    margin: 8px 0;
  }
  &-select {
    height: calc(100% - 48px);
    overflow-y: auto;
  }
  &:hover {
    color: $black;
  }
}
.label {
  padding: 1px 8px;
  margin: 5px;
  border-radius: 1em;
}
.dropdown {
  display: inline;
}
.input-group-text {
  background: none;
  border: none;
  border-radius: 25px;
  background-color: $white;
}
.tag {
  font-size: 14px;
  font-weight: bold;
  line-height: 1.29;
  letter-spacing: -0.1px;
  color: $black;
  border-bottom: 1px solid #e0e0e0;
  padding: 16px;
}
.disable-content {
  pointer-events: none;
  opacity: 0.5;
}
</style>
